<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-container">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'modal-container',
  };
</script>

<style lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.498039);
    display: table;
    transition: opacity .25s ease;

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-container {
      vertical-align: middle;
      margin: 0px auto;
      transition: all .25s ease;
    }
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: translate(0, 25%);
    transform: translate(0, 25%);
  }
</style>



// WEBPACK FOOTER //
// ModalContainer.vue?7ee71e04